export interface NewsItem {
  id: string;
  slug: string;
  title: string;
  category: "Statutory Notice" | "Platform Update" | "Engineering Dispatch" | "Company Release";
  timelineType?: "Milestone" | "Future Vision" | "Roadmap";
  publishedAt: string;
  summary: string;
  author: string;
  featured?: boolean;
  content: string;
  externalLink?: string;
}

export const INITIAL_NEWS_ITEMS: NewsItem[] = [
  {
    id: "NEWS-2026-01",
    slug: "official-incorporation-radiece-private-limited-21-july-2026",
    title: "Official Incorporation of RADIECE PRIVATE LIMITED under Ministry of Corporate Affairs (MCA)",
    category: "Statutory Notice",
    timelineType: "Milestone",
    publishedAt: "2026-07-21",
    summary: "RADIECE PRIVATE LIMITED was officially incorporated on 21 July 2026 under the Companies Act, 2013 (CIN: U58200KL2026PTC104862, GSTIN: 32AAQCR1162B1ZR) with registered office in Kakkanad, Ernakulam, Kerala.",
    author: "Corporate Governance & Compliance Desk",
    featured: true,
    content: `
**KAKKANAD, KOCHI, INDIA — July 21, 2026** — RADIECE PRIVATE LIMITED announces its official corporate incorporation under the Companies Act, 2013, registered with the Registrar of Companies (RoC - Ernakulam), Ministry of Corporate Affairs, Government of India.

### Statutory Credentials & Entity Information:
- **Full Corporate Name**: RADIECE PRIVATE LIMITED (Research And Development Infrastructure for Electronic and Computing Equipment)
- **Corporate Identification Number (CIN)**: \`U58200KL2026PTC104862\`
- **Incorporation Date**: \`21st July 2026\`
- **Goods and Services Tax Identification Number (GSTIN)**: \`32AAQCR1162B1ZR\`
- **Registered Office**: Suite No. 1034, Heiley Offices, 2nd Floor KC Arcade, Near TV Centre, CSEZ P.O, Kakkanad, Ernakulam - 682037, Kerala, India
- **Authorized Classification**: Private Limited Company (Software Engineering, Hardware Prototyping & Technology Services)

All corporate engagements, digital infrastructure, and client contracts adhere to the **Digital Personal Data Protection (DPDP) Act 2023** and **CERT-In** cybersecurity guidelines.
    `,
  },
  {
    id: "NEWS-2026-02",
    slug: "rabuos-enterprise-platform-development-q4-beta",
    title: "Future Vision & Active Roadmap: RaBuOS Business Platform Public Beta Targeted for Q4 2026",
    category: "Platform Update",
    timelineType: "Future Vision",
    publishedAt: "2026-08-10",
    summary: "RaBuOS is currently in active development on Bun and TypeScript. The engineering team has scheduled a Public Beta release target for Q4 2026 (~Dec).",
    author: "Enterprise Platform Practice",
    featured: false,
    content: `
**KAKKANAD, KOCHI, INDIA — August 10, 2026** — RADIECE PRIVATE LIMITED has published the architecture vision and developmental roadmap for **RaBuOS (Radiece Business Operating System)**, its upcoming all-in-one enterprise business platform.

### Active Development Status & Target Milestones:
- **Current Stage**: Active In-House Architecture & Component Prototyping
- **Public Beta Target**: **Q4 2026 (~December)** for early design adopters
- **Core Technology Stack**: Native Bun runtime, TypeScript, SQLite/PostgreSQL with WebSocket streaming
- **Key Module Blueprints**: Interactive visual DAG task workflows, automated Indian statutory GST & MCA compliance tracking, zero-trust RBAC permissions, and IoT sensor bridges.

*Note: RaBuOS is currently undergoing internal development and testing. Early architectural blueprints and preview access registration are available through our technical contact desk.*
    `,
  },
  {
    id: "NEWS-2026-03",
    slug: "planned-deep-tech-embedded-iot-prototyping-facility-kakkanad",
    title: "Future Vision: Planned Deep-Tech Embedded Hardware & IoT Prototyping Lab at Kakkanad",
    category: "Engineering Dispatch",
    timelineType: "Future Vision",
    publishedAt: "2026-08-14",
    summary: "Architectural blueprint and planned facility setup for in-house PCB layout design, ESP32/ARM firmware prototyping, and 865 MHz ISM wireless telemetry testing.",
    author: "Hardware & Robotics Practice",
    featured: false,
    content: `
**KAKKANAD, KOCHI, INDIA — August 14, 2026** — RADIECE PRIVATE LIMITED has outlined the planned engineering blueprint for its dedicated electronic prototyping and robotics laboratory in Kakkanad, Ernakulam.

### Planned Facility Scope & Future Capabilities:
- **Embedded Circuit Prototyping**: In-house schematic capture, multilayer PCB design, and micro-soldering workstations.
- **Wireless Telemetry Bench**: RF spectrum validation for the Indian de-licensed **865–867 MHz ISM band** (LoRaWAN & custom mesh).
- **Microcontroller Toolchains**: Firmware testing environments for ESP32-S3, ARM Cortex-M4/M7, and Nordic Semiconductor BLE SoCs.
- **Industrial Automation Testbeds**: Sensor calibration and motor control logic testing for robotics automation.

*This facility plan represents our upcoming infrastructure milestone to support first-principles hardware development across South India.*
    `,
  },
  {
    id: "NEWS-2026-04",
    slug: "planned-technical-education-engineering-curricula-rollout",
    title: "Future Vision & Curriculum Blueprint: Industry-Aligned Engineering Education Tracks",
    category: "Company Release",
    timelineType: "Future Vision",
    publishedAt: "2026-08-16",
    summary: "Proposed syllabus frameworks for Python Full-Stack, React/Next.js, and Embedded IoT engineering designed to bridge academic study with production industry standards.",
    author: "Technical Education Practice",
    featured: false,
    content: `
**KAKKANAD, KOCHI, INDIA — August 16, 2026** — RADIECE has formulated structured technology curriculum blueprints aimed at bridging the gap between theoretical computer science and production-grade engineering.

### Planned Training Tracks:
- **Python Full-Stack & Systems**: Clean syntax, Django/FastAPI microservices, relational modeling, and automated testing.
- **Modern Web Engineering**: React 18, Next.js App Router, TypeScript, and Docker containerized deployments.
- **Embedded Systems & IoT Hardware**: Direct microcontroller register programming, FreeRTOS task scheduling, and MQTT sensor integration.
- **Cyber Security & Ethical Defense**: OWASP Top 10 mitigation, secure code auditing, and CERT-In compliance protocols.

*Syllabi and customized corporate workforce upskilling schedules are currently being organized for upcoming institutional cohorts.*
    `,
  },
];
